export default {
  SET_FAQS: function (state, payloads) {
    state.faqs = payloads;
  },
};
